import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import {
  MuiThemeProvider,
  createTheme,
  withStyles
} from '@material-ui/core/styles';
import LockIcon from '@material-ui/icons/Lock';
import EfrontBackground from '../themes/assets/EfrontBackground.jpg';
import { translate, userLogin, TopToolbar } from 'react-admin';
import Notification from './forked/layout/Notification';
import { SolsticeTheme } from '../themes/SolsticeTheme';

const styles = theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'flex-start',
    background: 'url(' + EfrontBackground + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  card: {
    minWidth: 300,
    marginTop: '6em'
  },
  avatar: {
    margin: '1em',
    display: 'flex',
    justifyContent: 'center'
  },
  icon: {
    backgroundColor: theme.palette.secondary.main
  },
  hint: {
    marginTop: '1em',
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.grey[500]
  },
  form: {
    padding: '0 1em 1em 1em'
  },
  input: {
    marginTop: '1em'
  },
  actions: {
    padding: '0 1em 1em 1em'
  }
});

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
  meta: { touched, error } = {},
  input: { ...inputProps },
  htmlFor,
  ...props
}) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    id={htmlFor}
    {...inputProps}
    {...props}
    fullWidth
  />
);

class Login extends Component {
  login = auth => {
    return this.props.userLogin(
      auth,
      this.props.location.state ? this.props.location.state.nextPathname : '/'
    );
  };
  render() {
    const { classes, loading, translate } = this.props;
    return (
      <div className={classes.main}>
        <Card className={classes.card}>
          <div className={classes.avatar}>
            <Avatar className={classes.icon}>
              <LockIcon />
            </Avatar>
          </div>
          <Form
            onSubmit={this.login}
            validate={values => {
              const errors = {};
              if (!values.tenant) {
                errors.tenant = translate('ra.validation.required');
              }
              if (!values.username) {
                errors.username = translate('ra.validation.required');
              }
              if (!values.password) {
                errors.password = translate('ra.validation.required');
              }
              return errors;
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <div className={classes.form}>
                  <div className={classes.input}>
                    <Field
                      autoFocus
                      name="tenant"
                      component={renderInput}
                      label="Client"
                      type="text"
                      htmlFor="tenant"
                      disabled={loading}
                    />
                  </div>
                  <div className={classes.input}>
                    <Field
                      name="username"
                      component={renderInput}
                      label={translate('ra.auth.username')}
                      htmlFor={translate('ra.auth.username')}
                      type="text"
                      disabled={loading}
                    />
                  </div>
                  <div className={classes.input}>
                    <Field
                      name="password"
                      component={renderInput}
                      label={translate('ra.auth.password')}
                      htmlFor={translate('ra.auth.password')}
                      type="password"
                      disabled={loading}
                    />
                  </div>
                </div>
                <TopToolbar className={classes.actions}>
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={loading}
                    className={classes.button}
                    fullWidth
                  >
                    {loading && <CircularProgress size={25} thickness={2} />}
                    {translate('ra.auth.sign_in')}
                  </Button>
                </TopToolbar>
              </form>
            )}
          </Form>
        </Card>
        <Notification />
      </div>
    );
  }
}

Login.propTypes = {
  authProvider: PropTypes.func,
  classes: PropTypes.object,
  previousRoute: PropTypes.string,
  translate: PropTypes.func.isRequired,
  userLogin: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ loading: state.admin.loading > 0 });

const EnhancedLogin = translate(
  connect(mapStateToProps, { userLogin })(withStyles(styles)(Login))
);

// We need to put the MuiThemeProvider decoration in another component
// Because otherwise the withStyles() HOC used in EnhancedLogin won't get
// the right theme
const LoginPage = props => (
  <MuiThemeProvider theme={createTheme(SolsticeTheme)}>
    <EnhancedLogin {...props} />
  </MuiThemeProvider>
);

export default LoginPage;
